// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import * as jwt_decode from 'jwt-decode';
import { rest } from 'lodash';
import { data } from 'jquery';
import { ConfigsLoaderService } from './configs-loader.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public authenticated: boolean;
  public user: any;
  public checkingInterval: any;
  public scopes;

  constructor(private msalService: MsalService, private readonly configsLoaderService: ConfigsLoaderService) {
    this.scopes = {
      scopes: [this.configsLoaderService.AZURE_AD_CLIENTID],
    };
  }


  public logOut() {
    sessionStorage.clear();
    this.msalService.logout();
  }
}
